import canUseDom from "rc-util/es/Dom/canUseDom";
import { isStyleSupport } from "rc-util/es/Dom/styleChecker";
export var canUseDocElement = function canUseDocElement() {
  return canUseDom() && window.document.documentElement;
};
export { isStyleSupport };